import { motion } from 'motion/react';

import styles from './Title.module.css';
import { memo } from 'react';

export const Title = memo(({ text = 'ПОШУМИМ!' }) => {
  const letters = text.split('').reverse();

  return (
    <div className={styles.text} dir="rtl">
      {letters.map((l, idx, arr) => {
        let initialIdx = 3;
        let oneLetterWidth = 6;
        let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

        return (
          <motion.div
            style={{ position: 'relative', zIndex: idx * -1 }}
            key={l + idx}
            initial={{ scale: 0, x: initialX }}
            animate={{ scale: 1, x: 0 }}
            transition={{ duration: 0.7, delay: idx * 0.15 }}
          >
            {l}
          </motion.div>
        );
      })}
    </div>
  );
});
